import { ReactNode } from 'react';
import {
  BodyText,
  TBodyTextProps,
} from '@/common/components/BodyText/BodyText';
import { Li, Ul } from '@/common/components/DOM/DOM';
import { Stack } from '@/common/components/Stack/Stack';
import { Translate } from '@/common/components/Translate/Translate';

type TBulletPointsProps = {
  title?: ReactNode;
  points: ReactNode[];
  size?: TBodyTextProps['size'];
  color?: TBodyTextProps['color'];
};

export function BulletPoints({
  title,
  points,
  size,
  color,
}: TBulletPointsProps) {
  return (
    <Stack gap="md">
      {title && (
        <BodyText size={size} color={color} bold>
          {title}
        </BodyText>
      )}
      <Ul>
        {points.map((point, index) => (
          <Li key={index} size={size} color={color}>
            <Translate size={size} color={color}>
              {point}
            </Translate>
          </Li>
        ))}
      </Ul>
    </Stack>
  );
}
